import axios from 'axios';
// import awsAuth from '@/utils/aws-auth';
import router from '@/router/index';
import store from '@/store/index';
import * as actions from '@/store/types/actions';

const HTTP = axios.create({
  baseURL: process.env.API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
});

HTTP.interceptors.response.use(response => response, (error) => {
  if (error.response.status === 401) {
    store.dispatch(actions.DO_LOGOUT)
      .then(() => {
        router.push({ name: 'login' });
      });
  }
  return Promise.reject(error);
});

const SEARCH = axios.create({
  baseURL: process.env.ES_ENDPOINT,
});

// SEARCH.interceptors.request.use((config) => {
//  if (process.env.ES_ENDPOINT.match(/amazonaws.com/i)) {
//    config.headers['Content-Type'] = 'application/json';
//    config.headers.Host = config.baseURL.replace(/http(s)?:\/{2}/, '');
//    config.headers['X-Amz-Date'] = new Date().toISOString().replace(/[:-]|\.\d{3}/g, '');
//   config.headers.Authorization = awsAuth.authorize(config);
//    const signedHeaders = config.headers;
//   delete signedHeaders.Host;
//    config.headers = signedHeaders;
//  }
//  return config;
// });

export {
  HTTP,
  SEARCH,
};



// WEBPACK FOOTER //
// ./src/utils/http.js